"use strict";
const textReadClasses = ['d:block', 'text:line-clamp:unset', 'pos:a', 'z:1', 'h:100p', 'w:100p', 't:0', 'l:0', 'scrbar:none', 'ov:x:h', 'ov:y:a', 'p:14'];
class ReviewCardComponent extends HTMLElement {
    opened = false;
    text = null;
    arrows;
    iconClose;
    constructor() {
        super();
        this.addEventListener('click', () => {
            if (this.text === null ||
                this.text.textContent === null ||
                this.text.textContent.length < 1)
                return;
            if (this.opened) {
                this.dataset.stateOpened = '0';
                this.dataset.stateScrollable = '0';
                this.arrows?.forEach(a => { a.hidden = true; });
                this.text.scrollTop = 0;
                this.iconClose?.setAttribute('hidden', '');
                this.text.classList.remove(...textReadClasses);
                this.opened = false;
            }
            else {
                this.iconClose?.removeAttribute('hidden');
                this.dataset.stateOpened = '1';
                this.text.classList.add(...textReadClasses);
                if (this.text.scrollHeight > this.text.clientHeight) {
                    this.dataset.stateScrollable = '1';
                    this.arrows?.forEach(a => { a.hidden = false; });
                }
                this.opened = true;
            }
        });
    }
    connectedCallback() {
        this.text = this.querySelector('[data-review-text]');
        this.arrows = this.querySelectorAll('[data-c-arrow]');
        this.iconClose = this.querySelector('[data-icon="#icon--close-x"]');
    }
}
customElements.define('review-card-component', ReviewCardComponent);
